<div id="showDifferencesContainer" class="flex flex-col"
     *ngrxLet="viewModel$; let value">
  <div id="showDifferencesContent" class="flex flex-col">

    <div id="differenceTableContainer">

      <!--reserved space for header row-->
      <div class="headerPlaceHolder"></div>

      <mat-table id="differenceTable"
                 [dataSource]="tableDataSource"
                 class="mat-elevation-z8"
                 [trackBy]="trackByFn"
                 [@blsGmbDifferenceRowAnimation]="value.blsGmbDifferencesState.forceAnimation && value.blsGmbDifferencesState.differences.length? 'start' : 'stop'"
                 (@blsGmbDifferenceRowAnimation.done)="onAnimationEnd()"
      >

        <!--COLUMNS -->

        <ng-container matColumnDef="fieldId">
          <mat-header-cell class="differenceTableColumn fieldIdColumn"
                           *matHeaderCellDef>
            <app-column-sorting-button columnName="Field Name"
                                       [sortDirection]="value.blsGmbDifferencesState.sorting || SortingEnum.NONE"
                                       (sortingChange)="toggleDifferenceSorting(value.blsGmbDifferencesState.sorting)"></app-column-sorting-button>
          </mat-header-cell>

          <!-- row name (field name) + content like black/whitelisting trigger etc -->
          <mat-cell class="differenceTableColumn fieldIdColumn fieldIdName"
                    [ngClass]="{
                      'text-green-10': isOutlinedCheckCircle(difference),
                      'text-neutral-60': isFieldBlacklisted(difference['fieldId'],
                        value.focusedLocation)
                    }"
                    *matCellDef="let difference">

            <!-- field name + black-/whitelisting trigger-->
            <div class="flex items-center"
                 *ngrxLet="getDataSourceIconType$(difference['fieldId']); let dataSourceIconType">
              <!-- field name-->
              <span class="max-w-[120px]">{{ getFieldNameByFieldID(difference['fieldId']) }}</span>

              <!-- JSON data src icon -->
              @if (shouldDisplayDataSourceIcon(difference['fieldId'])) {
                <mat-icon
                  class="dataSourceIcon pt-[2px] pl-[5px]"
                  [ngClass]="dataSourceIconType"
                  matTooltip="{{ getDataSourceIconTooltipKey(dataSourceIconType) | translate }}"
                  [svgIcon]="getDataSourceIconName(dataSourceIconType)"
                  matTooltipPosition="below">
                </mat-icon>
              }

              <!-- black-/whitelisting trigger -->
              @if (isFieldBlacklistAble(difference['fieldId'])) {
                <button
                  mat-icon-button
                  [disabled]="!!value.blsGmbDifferencesState.blacklistingInProgress"
                  [ngClass]="{
                      'blacklist-btn': true,
                      'is-blacklisted': isFieldBlacklisted(difference['fieldId'],
                        value.focusedLocation),
                      'can-whitelist': isFieldBlacklisted(difference['fieldId'],
                        value.focusedLocation),
                      'can-blacklist': !isFieldBlacklisted(difference['fieldId'],
                        value.focusedLocation)
                    }"
                  (click)="
                      performBlacklistOperation(
                        isFieldBlacklisted(difference['fieldId'], value.focusedLocation) ?
                          'whitelist' : 'blacklist',
                              difference['fieldId'], value.focusedLocation.id)"
                  [matTooltip]="
                      capitalizeFirstLetter(
                        isFieldBlacklisted(difference['fieldId'], value.focusedLocation) ?
                          'whitelist' : 'blacklist'
                      )
                    "
                  >
                  <!--
                  Showing both icons here and letting CSS decide which one to show/hide based on the
                  hover state of the parent button. This is needed when we want to show the
                  `whitelist` button only upon hover AND only when the field in question is
                  already blacklisted: See spec:
                  https://xd.adobe.com/view/178e35eb-cde1-4813-b75b-5837012b07dc-42dd/screen/92d37fc6-38e8-4b03-a110-f62b835c5b8e/specs/
                  -->
                  @if (value.blsGmbDifferencesState.blacklistingInProgress !==
                    difference['fieldId']) {
                    <mat-icon class="blacklist-icon"
                      [svgIcon]="'blacklist_locations'">
                    </mat-icon>
                  }
                  @if (value.blsGmbDifferencesState.blacklistingInProgress !==
                    difference['fieldId']) {
                    <mat-icon class="whitelist-icon"
                      [svgIcon]="'whitelist_locations'">
                    </mat-icon>
                  }
                  <!-- spinner -->
                  @if (value.blsGmbDifferencesState.blacklistingInProgress ===
                    difference['fieldId']) {
                    <mat-spinner id="action-active-spinner"
                    [diameter]="24"></mat-spinner>
                  }
                </button>
              }

              <div
                  class="w-5 h-5 flex-row flex items-center justify-center rounded ml-1"
                  [class.bg-green-90]="difference.showTranslation && !isTranslationLoading(
                    difference['fieldId'],
                    value.blsGmbDifferencesState.rowsLoadingTranslations)">
                @if (isTranslatable(difference['fieldId'])) {
                  <button
                    mat-icon-button
                    class="toggle-translation"
                    [ngClass]="{
                      'translation-loading': isTranslationLoading(difference['fieldId'],
                        value.blsGmbDifferencesState.rowsLoadingTranslations),
                      'is-translation': difference['showTranslation']}"
                    [disabled]="isTranslationLoading(difference['fieldId'],
                      value.blsGmbDifferencesState.rowsLoadingTranslations)"
                    (click)="toggleShowTranslation(difference, value.focusedLocation)"
                    [matTooltip]="difference.showTranslation ? 'Show original' : 'Show translation'"
                  >
                    @if (!isTranslationLoading(difference['fieldId'],
                      value.blsGmbDifferencesState.rowsLoadingTranslations)) {
                      <mat-icon
                        [svgIcon]="'translate'">
                      </mat-icon>
                    }
                    <!-- spinner -->
                    @if (isTranslationLoading(difference['fieldId'],
                      value.blsGmbDifferencesState.rowsLoadingTranslations)) {
                      <mat-spinner
                      [diameter]="24"></mat-spinner>
                    }
                  </button>
                }
              </div>
            </div>

            <!-- extra field explanation -->
            @if (getFieldExplanation(difference['fieldId']); as extraText) {
              <span
                  class="block text-neutral-30 text-body-small mt-[4px]">
                {{extraText}}
              </span>
            }
          </mat-cell>

          <mat-footer-cell class="differenceTableColumn fieldIdColumn"
                           *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <!--
              Iterate all 3 column definitions and render
              1) the checkbox (check-circle) column followed by
              2) the diff value column (containing the highlighted diffs)
        -->
        @for (column of columnDefinitions; track column) {
          <!-- CHECKBOX COLUMN (checkbox circle) -->
          <ng-container [matColumnDef]="column.action">
            <!-- HEADER CELL -->
            <mat-header-cell class="checkboxColumn items-end flex flex-row"
                             *matHeaderCellDef>
              <mat-menu #localMenu="matMenu"
                        yPosition="below"
                        (closed)="toggleInfoMenu(column.action,
                          value.blsGmbDifferencesState.infoMenuVisibility)"
                        class="infoMenu">
                {{ column.infoMenu.content }}
              </mat-menu>

              <button mat-icon-button
                      [matMenuTriggerFor]="localMenu"
                      [ngClass]="{infoMenuOpened: value.blsGmbDifferencesState.infoMenuVisibility[column.action]}"
                      (menuOpened)="toggleInfoMenu(column.action, value.blsGmbDifferencesState.infoMenuVisibility)">
                <mat-icon svgIcon="help_outline"></mat-icon>
              </button>
            </mat-header-cell>

            <!-- ACTUAL CELL -->
            <mat-cell class="checkboxColumn clickableCell"
                      [ngClass]="{
                        'cursor-not-allowed': isFieldBlacklisted(difference['fieldId'], value.focusedLocation) &&
                          column.isBlacklistAble(column.action) || column.checkbox.isCheckCircleHidden(difference['fieldId'],
                          column.action),
                        'cursor-pointer': !(isFieldBlacklisted(difference['fieldId'], value.focusedLocation) &&
                          column.isBlacklistAble(column.action)) && !column.checkbox.isCheckCircleHidden(difference['fieldId'],
                          column.action),
                        'invisible pointer-events-none': !column.visibility.isVisible(value.blsGmbDifferencesState.columnVisibility),
                        'checkboxWMarkerColumn': difference['fieldId'] === 'latLng'
                      }"
                      *matCellDef="let difference"
                      (click)="!column.checkbox.isCheckCircleHidden(difference['fieldId'],
                        column.action) && onCell__click(column, difference, $event, value.focusedLocation)">
              <div class="flex w-full justify-end">
                <mat-checkbox [ngModel]="difference[column.checkbox.checkCircleModelName]"
                              [class]="isOutlinedCheckCircle(difference) ?
                                'checkcircleOutlineTeal' : 'checkcircle'"
                              [class.hidden]="column.checkbox.isCheckCircleHidden(difference['fieldId'],
                                column.action)"
                              [disabled]="isFieldBlacklisted(difference['fieldId'], value.focusedLocation) &&
                                column.isBlacklistAble(column.action) ||
                                column.checkbox.isCheckCircleHidden(difference['fieldId'])
                            ">
                </mat-checkbox>
                @if (difference['fieldId'] === 'latLng') {
                  <div class="mt-[13px]">
                    @if (column.action === actions.updateGmb) {
                      <mat-icon
                      svgIcon="validated_coordinates_marker"></mat-icon>
                    }
                    @if (column.action === actions.acceptDifference) {
                      <mat-icon
                      svgIcon="gbp_coordinates_marker"></mat-icon>
                    }
                  </div>
                }
              </div>

            </mat-cell>
            <mat-footer-cell class="checkboxColumn"
                             *matFooterCellDef>
            </mat-footer-cell>
          </ng-container>

          <!-- DISPLAY COLUMN (containing the highlighted diffs) -->
          <ng-container [matColumnDef]="column.display.backendDifferenceName">
            <!-- HEADING -->
            <mat-header-cell class="differenceTableColumn valueColumn flex"
                             *matHeaderCellDef>
              <app-column-sorting-button [columnName]="column.display.heading"
                                         sortingDisabled="true"></app-column-sorting-button>
              @if (column.visibility.shouldShowToggleBtn(column.action)) {
                <button mat-icon-button
                        [disableRipple]="true"
                        [disabled]="column.visibility.shouldDisableToggleBtn(
                          column.action,
                          value.blsGmbDifferencesState.columnVisibility)"
                        (click)="column.visibility.toggleColumn(column.action,
                          value.blsGmbDifferencesState.columnVisibility)"
                        style="width: 22px; height: 22px"
                        class="flex items-center">
                  <mat-icon style="margin-left: 4px; font-size: 22px; height: 22px"
                            [ngClass]="{
                              'hover:text-neutral-10': !column.visibility.shouldDisableToggleBtn(
                                column.action,
                                value.blsGmbDifferencesState.columnVisibility),
                              'text-neutral-90': column.visibility.shouldDisableToggleBtn(
                                column.action,
                                value.blsGmbDifferencesState.columnVisibility)
                            }"
                            [svgIcon]="column.visibility.getIconName(
                              value.blsGmbDifferencesState.columnVisibility)">
                  </mat-icon>
                </button>
              }
            </mat-header-cell>

            <!-- ACTUAL CELL CONTENT -->
            <mat-cell class="differenceTableColumn valueColumn clickableCell"
                      *matCellDef="let difference"
                      (click)="!column.checkbox.isCheckCircleHidden(difference['fieldId'],
                        column.action) && onCell__click(column, difference, $event, value.focusedLocation)"
                      [ngClass]="{
                        'cursor-not-allowed': isFieldBlacklisted(difference['fieldId'], value.focusedLocation) &&
                          column.isBlacklistAble(column.action) || column.checkbox.isCheckCircleHidden(difference['fieldId'],
                          column.action),
                        'cursor-pointer': column.visibility.isVisible(value.blsGmbDifferencesState.columnVisibility) &&
                          !(isFieldBlacklisted(difference['fieldId'], value.focusedLocation) &&
                          column.isBlacklistAble(column.action)) &&
                          !column.checkbox.isCheckCircleHidden(difference['fieldId'],
                          column.action),
                        'invisible pointer-events-none': !column.visibility.isVisible(
                          value.blsGmbDifferencesState.columnVisibility)
                      }">
              <ng-container>
                @if (
                  difference
                  && difference[column.display.backendDifferenceName]; as differenceContent) {
                  <div
                    [class]="column.display.backendDifferenceName + 'Container'">
                    <!-- bottom margin has to be increased for the last value line so that top and bottom margins-->
                    <!-- within a value column are equal-->
                    @for (line of getDifferenceLines(difference, column.action); track line) {
                      <div class="lineContainer">
                        <span class="differencesContainer"
                              [innerHTML]="line.html">
                        </span>
                        <!-- new tab trigger -->
                        <!-- stopped event propagation coz clicking the icon would select the difference otherwise-->
                        @if (line.url) {
                          <a
                              mat-icon-button
                              (click)="$event.stopPropagation()"
                              [href]="prepareUrlHref(line.url)"
                              target="_blank" class="open-url-element"
                              appGtagEvent trackOn="click" action="open link/photo"
                              category="Navigation [overhaul]"
                              [params]="{ event_label: 'Open link/photo from differences popup' }">
                            <mat-icon svgIcon="open_in_new"></mat-icon>
                          </a>
                        }
                      </div>
                    }
                    <!-- photo preview -->
                    <!-- Setting the max height to 120px (1/2 of the map height) to alleviate BLS-3563 -->
                    @if (isTextViableImageSrc(differenceContent, difference)) {
                      <img
                        [src]="differenceContent"
                        alt="Image not available"
                        class="block w-auto h-full max-h-[120px] mt-4">
                    }
                    <!-- INTERACTIVE COORDINATES MAP -->
                    @if (column.display.getMapConfig(column.action, difference); as mapConfig) {
                      <!-- a wrapper for the 240px tall map-->
                      <div class="my-[16px] h-[480px]">
                        <!--
                        The mat-row grandparent is position:relative so this child will fill
                        the row's width entirely. If we don't set the `left`, it'll be inherited
                        and will thus start wherever the LSC column starts.
                        The only thing we need to set is the width which should be based
                        on the available 100%. 300px is arbitrary but works well.
                        -->

                        <div class="absolute h-[480px]"
                          style="width: calc(100% - 300px); right: 24px">
                          <!-- distance -->
                        <div class="absolute z-10
                                    left-[8px] top-[8px]
                                    p-[8px]
                                    rounded-md
                                    text-neutral-30
                                    bg-white shadow-md
                                    flex justify-center items-center">
                            Distance between the coordinates: <span
                          class="text-neutral-10 self-center">{{mapConfig.distance}}</span>
                          <mat-divider vertical class="h-[24px] ml-3 mr-[6px]"></mat-divider>
                          <mat-icon
                              [svgIcon]="value.blsGmbDifferencesState.customPinsMinimized ?
                                'maximize_pin' : 'minimize_pin'"
                              class="cursor-pointer"
                              (click)="togglePinSize(value.blsGmbDifferencesState.customPinsMinimized)">
                          </mat-icon>
                        </div>

                        <div class="relative block
                                    overflow-hidden
                                    w-full h-full
                                    rounded-md
                                    border-solid border-[1px] border-neutral-90">
                          <app-bls-gmb-differences-map [renderIntoContainerId]="'gmb-diff-map'"
                                                       [locations]="mapConfig.locations"></app-bls-gmb-differences-map>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              } @else {
                <span class="noValue">No data</span>
              }
            </ng-container>
          </mat-cell>
          <!-- SELECT ALL TOGGLE -->
          <mat-footer-cell class="differenceTableColumn valueColumn"
            *matFooterCellDef>
            <button mat-button class="text-green-10"
              id="updateAllButton"
                      [disabled]="(areAllFieldsBlacklisted(value.blsGmbDifferencesState.differences,
                        value.focusedLocation) &&
                        column.action !== actions.acceptDifference) ||
                        !column.visibility.isVisible(value.blsGmbDifferencesState.columnVisibility) ||
                        value.blsGmbDifferencesState.differences.length === 0"
                      (click)="onSelectAll__click(column.action,
                        value.blsGmbDifferencesState.differences,
                        value.focusedLocation)">{{ column.display.getSelectAllBtnText(column.action,
              value.blsGmbDifferencesState.differences,
              value.focusedLocation) }}
            </button>
          </mat-footer-cell>
        </ng-container>
      }

      <!--ROWS -->
      <mat-header-row *matHeaderRowDef="displayedColumns;"
          [ngClass]="{'pr-[10px]': value.blsGmbDifferencesState.isTableVerticallyOverflowing}"
          @.disabled>
      </mat-header-row>
      <mat-row class="items-start"
        *matRowDef="let row; columns: displayedColumns; let last = last;"
        [ngClass]="{
           'relative overflow-x-hidden': true,
           'bg-blue-98': isOutlinedCheckCircle(row),
           'hideBottomBorder': value.blsGmbDifferencesState.isTableVerticallyOverflowing && last }">
      </mat-row>
      <!--'sticky: true' causes bottom border to sporadically disappear BLS-3072-->
      <mat-footer-row class="mt-0"
        [ngClass]="{'pr-[10px]': value.blsGmbDifferencesState.isTableVerticallyOverflowing}"
        *matFooterRowDef="displayedColumns;"
        @.disabled></mat-footer-row>

      <!-- NO DATA value cell -->
      <ng-template #noValue>
        <span class="noValue">No data</span>
      </ng-template>

      <div *matNoDataRow
           class="flex flex-col justify-center items-center h-full"
           @.disabled>
        <img src="assets/images/icon/location_placeholder.svg" alt="No location"
          class="h-1/2 max-h-[125px]"/>
          <p>There are no differences between BLS and GBP for this location or there is no selected location.</p>
        </div>
      </mat-table>

      <!--reserved space for footer row-->
      <div class="footerPlaceHolder"></div>

    </div>
  </div>

  <div id="showDifferencesActionBar">
    <div class="flex-grow"></div>
    <!-- click-event has to be explicitly defined because clickAction is set to 'noop' by default in this component (for checkcircles to work with outside-clicks) -->
    <mat-checkbox [ngModel]="value.blsGmbDifferencesState.continueToNextLocation"
                  [disabled]="(getCurrentRowIndex(value.focusedLocation?.id, true) === value.total) ||
                    !value.blsGmbDifferencesState.differences.length"
                  matTooltip="{{ getCurrentRowIndex(value.focusedLocation?.id, true) === value.total ?
                    'You have reached the end of the current page' : ''}}"
                  matTooltipPosition="above"
                  (click)="!((getCurrentRowIndex(value.focusedLocation?.id, true) === value.total) ||
                    !value.blsGmbDifferencesState.differences.length) &&
                    toggleContinueToNextLocation()">Continue to the next location after saving
    </mat-checkbox>
    <button matButton="outlined"
            class="px-4 mr-4 ml-2"
            (click)="undoChanges(value.focusedLocation)"
            [disabled]="isUndoChangesButtonDisabled(value.isUnsavedChange,
                                                 value.updatingDiffsInProgress,
                                                 value.blsGmbDifferencesState.coordinateRevalidationInProgress,
                                                 value.updatingLocationListInProgress,
                                                 value.total)"
            tabindex="-1">Undo changes
    </button>
    <button mat-flat-button
            id="confirmButton"
            (click)="onConfirmButtonClick(value.focusedLocation,
                                          value.blsGmbDifferencesState.differences,
                                          value.isUnsavedChange,
                                          value.blsGmbDifferencesState.continueToNextLocation)"
            [disabled]="isConfirmButtonDisabled(value.isUnsavedChange,
                                                 value.blsGmbDifferencesState.continueToNextLocation,
                                                 value.updatingDiffsInProgress,
                                                 value.blsGmbDifferencesState.coordinateRevalidationInProgress,
                                                 value.updatingLocationListInProgress,
                                                 value.total)"
      tabindex="-1">
      <span>
        @if (value.updatingDiffsInProgress ||
          value.updatingLocationListInProgress ||
          value.blsGmbDifferencesState.coordinateRevalidationInProgress) {
          <mat-spinner id="spinner" [diameter]="18"></mat-spinner>
        }
        @if (!(value.updatingDiffsInProgress ||
          value.updatingLocationListInProgress ||
          value.blsGmbDifferencesState.coordinateRevalidationInProgress)) {
          <span>{{getConfirmButton__TRANS_KEY(
            value.isUnsavedChange,
            value.blsGmbDifferencesState.continueToNextLocation) | translate}}</span>
        }
      </span>
    </button>
    @if (getCurrentRowIndex(value.focusedLocation?.id, true)) {
      <mat-divider vertical class="mx-4"></mat-divider>
      <app-jumper
          #jumper
          [currentItemIndex]="getCurrentRowIndex(value.focusedLocation?.id, true)"
          [numberOfItems]="value.total"
          (currentItemChanged)="loadNextRow($event, value.focusedLocation?.id, value.isUnsavedChange)"
          [showSideArrows]="true">
      </app-jumper>
    }
  </div>

</div>
